import FormContainer from "@app/components/forms/container/FormContainer";
import { LoadingButton } from "@shortsworks/ui";
import { Outlet, Link } from "react-router-dom";

export const LoginLayout = () => {
  return (
    <div className="w-full h-screen lg:grid lg:min-h-[600px] lg:grid-cols-2 xl:min-h-[800px]">
      <div className="hidden bg-muted lg:block">
        {/*<Image*/}
        {/*  src="/placeholder.svg"*/}
        {/*  alt="Image"*/}
        {/*  width="1920"*/}
        {/*  height="1080"*/}
        {/*  className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"*/}
        {/*/>*/}
      </div>
      <Outlet />
    </div>
  );
};
